import * as React from "react";
import Input from "../Input-new/Input";
import Textarea from "../Textarea-new/Textarea";
import Dropdown from "../Dropdown/Dropdown";

const SellerInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
}) => {
  return (
    <div className="Seller-info">
      <div className="Seller-info_column">
        <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          name="FIRST_NAME"
          label="First Name"
          value={data.FIRST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          required
          className="Seller-info_column_item"
          valueType="text"
          name="LAST_NAME"
          label="Last Name"
          value={data.LAST_NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="phone"
          name="PHONE"
          label="Phone"
          value={data.PHONE}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Seller-info_column_item"
          valueType="email"
          name="EMAIL"
          label="Email"
          value={data.EMAIL}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Seller-info_column_item"
          data={data}
          optionsType="profiles"
          value={data.PROFILE}
          valueKey="PROFILE"
          label="Profile"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Textarea
          className="Seller-info_column_item text-area"
          label="Notes"
          name="NOTES"
          value={data.NOTES}
          maxWidth="100%"
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default SellerInfo;
